import React, { useCallback, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { DarkMode, LightMode, Menu } from "@mui/icons-material";

import Fade from "react-reveal/Fade";

import { THEMES, ICON_MAP } from "../common.constants.js";

import Theme from "../../../app.context.js";

import routes from "../../../assets/data/routes.json";

import "./header.scss";

const ThemeSwitcher = ({ theme, setTheme, className }) => {
    const handleThemeSwitch = useCallback(() => {
        setTheme((theme) =>
            theme === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={className} onClick={handleThemeSwitch}>
            {theme === THEMES.LIGHT ? (
                <Fade key={THEMES.LIGHT} top>
                    <LightMode className="themeIcon" />
                </Fade>
            ) : (
                <Fade key={THEMES.DARK} bottom>
                    <DarkMode className="themeIcon" />
                </Fade>
            )}
        </div>
    );
};

const HamBurgerMenu = ({ className, openSlideMenu }) => {
    return (
        <div className={className}>
            <Fade>
                <Menu onClick={() => openSlideMenu()} />
            </Fade>
        </div>
    );
};

const Header = ({ openSlideMenu }) => {
    const { theme, setTheme } = useContext(Theme);

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className="header fullWidth">
            <div className="headerContent flexContainer fullSpace">
                <div className="flexContainer navBrand">
                    <div className="ml-1">AT</div>
                </div>

                <div className="flexContainer flexGrow">
                    <div className="flexContainer flexGrow leftContent">
                        {routes.map(({ id, label, route, icon }) => (
                            <div
                                key={id}
                                className={`navItem ${
                                    location.pathname === route
                                        ? "selected"
                                        : ""
                                }`}
                                onClick={() => navigate(route)}
                            >
                                {ICON_MAP[icon]}
                                {label}
                            </div>
                        ))}
                    </div>
                    <div className="flexContainer rightContent mr-1">
                        <ThemeSwitcher
                            className="navItem"
                            theme={theme}
                            setTheme={setTheme}
                        />
                        <HamBurgerMenu
                            className="navItem hamBurgerMenuContainer"
                            openSlideMenu={openSlideMenu}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
